"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMS_CODE_LENGTH = void 0;
exports.SMS_CODE_LENGTH = 4;
